import { MinusIcon, PlusIcon } from "@heroicons/react/20/solid"
import React, { useState } from "react"

export default function PlusMinusInput({ value, valueIncrement, valueMinimum, valueMaximum, onUpdate }) {

  const [count, setCount] = useState(value)

  const decrement = () => {
    const newValue = value - valueIncrement
    if (newValue >= valueMinimum) {
      setCount(newValue)
      onUpdate(newValue)
    }
  }

  const increment = () => {
    const newValue = value + valueIncrement
    if (newValue <= valueMaximum) {
      setCount(newValue)
      onUpdate(newValue)
    }
  }

  const decrementIsDisabled = value === valueMinimum
  const incrementIsDisabled = value === valueMaximum

  return (
    <div
      className="flex overflow-hidden rounded-md ring-1 ring-white ring-opacity-10"
    >
      <button
        className="h-9 w-9 shrink-0 focus:ring-inset focus:rounded-l focus:ring-blue-100 active:bg-gray-200 flex items-center justify-center bg-white group disabled:cursor-not-allowed"
        disabled={decrementIsDisabled}
        onClick={decrement}
      >
        <MinusIcon className="text-gray-800 group-disabled:text-gray-400/80 w-6 h-auto" />
      </button>
      <input
  type="text"
  className="h-9 text-gray-800 bg-gray-100 flex-1 border-x border-gray-300 border-y-0 outline-0 ring-0 focus:ring-0 focus:outline-0 focus:border-gray-300 text-center min-w-[50px] sm:w-auto"
  name="quantity"
  disabled={true}
  value={count}
/>
      <button
        className="h-9 w-9 shrink-0 focus:ring-inset focus:rounded-r focus:ring-blue-100 active:bg-gray-200 flex items-center justify-center bg-white group disabled:cursor-not-allowed"
        disabled={incrementIsDisabled}
        onClick={increment}
      >
        <PlusIcon className="text-gray-800 group-disabled:text-gray-400/80 w-6 h-auto" />
      </button>
    </div>
  )
}